import { render } from "./Playground.vue?vue&type=template&id=7b23a814&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b23a814"]])

export default __exports__